import { getLocale, getProfileId } from 'lib/store';
import { apiClient } from 'services/api-client';
import { PreferenceUpdateData, UserPreference } from './type';

export const getUserPreference = async () => {
  return (await apiClient.get('/user-preference', {
    params: {
      os: 'web',
      locale: getLocale(),
      profile_id: getProfileId(),
    },
  })) as UserPreference;
};

export const postUserPreference = async (data: UserPreference) => {
  return await apiClient.post(
    `/user-preference?os=web&locale=${getLocale()}&profile_id=${getProfileId()}`,
    data
  );
};

export const patchUserPreference = async (data: PreferenceUpdateData) => {
  return await apiClient.patch(
    `/user-preference?os=web&locale=${getLocale()}&profile_id=${getProfileId()}`,
    data
  );
};

export const postWhatsappVerification = async (data: {
  otp_value?: string;
  type: 'send_otp' | 'validate_otp';
}) => {
  const { otp_value, type } = data;
  return await apiClient.post(
    `/whatsapp-verification?type=${type}&os=web&locale=${getLocale()}&profile_id=${getProfileId()}`,
    { ...(type === 'validate_otp' && { otp_value }) }
  );
};
